import Expandable from './Expandable'

export default Expandable
// eslint-disable-next-line import/export
export * from './Expandable'
